/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_1Inputs */

const da_privacy_retention_1 = /** @type {(inputs: Privacy_Retention_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto og oplysninger under Om dig: indtil du sletter dem eller beder os om det.`)
};

/** @type {(inputs: Privacy_Retention_1Inputs) => LocalizedString} */
const en_privacy_retention_1 = da_privacy_retention_1;

/**

* @param {Privacy_Retention_1Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_1 = /** @type {((inputs?: Privacy_Retention_1Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_1Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_1(inputs)
	return /** @type {LocalizedString} */ ("Konto og oplysninger under Om dig: indtil du sletter dem eller beder os om det.")
});